module.exports = __webpack_public_path__ + "img/Oracles_bc.19a77d90.svg";